import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import EdanData from 'model/Edan'
import EdanDataRepository from 'clients/db/EdanDataRepository'
import { AppThunk } from 'store'

interface EdanDataState {
  isLoading: boolean
  isUpdatedSuccessfully: boolean
  edanData: any[]
}

const initialState: EdanDataState = {
  isLoading: false,
  isUpdatedSuccessfully: false,
  edanData: [],
}

function startLoading(state: EdanDataState) {
  state.isLoading = true
}

const edanSlice = createSlice({
  name: 'edanData',
  initialState,
  reducers: {
    fetchedanDataStart: startLoading,
    createedanDataStart: startLoading,
    updateedanDataStart: startLoading,
    fetchedanDataSuccess(state, { payload }: PayloadAction<any[]>) {
      state.isLoading = false
      state.edanData = payload
    },
    createedanDataSuccess(state) {
      state.isLoading = false
    },
    updateedanDataSuccess(state, { payload }: PayloadAction<any[]>) {
      state.isLoading = false
      state.edanData = payload
    },
  },
})

export const {
  fetchedanDataStart,
  fetchedanDataSuccess,
  createedanDataStart,
  createedanDataSuccess,
  updateedanDataStart,
  updateedanDataSuccess,
} = edanSlice.actions

export const fetchedanData = (): AppThunk => async (dispatch) => {
  console.log(dispatch)
  dispatch(fetchedanDataStart())

  const edanData = await EdanDataRepository.search()
  console.log('edanData' + edanData)
  dispatch(fetchedanDataSuccess(edanData))
}

export const createedanData = (
  edanData: EdanData,
  onSuccess?: (edanData: EdanData) => void,
): AppThunk => async (dispatch) => {
  dispatch(createedanDataStart())
  const newedanData = await EdanDataRepository.saveOrUpdate(edanData)
  dispatch(createedanDataSuccess())
  if (onSuccess) {
    onSuccess(newedanData)
  }
}

export const deleteEdan = (id: string, onSuccess?: () => void): AppThunk => async (dispatch) => {
  const answer = await EdanDataRepository.delete({ id: id })
  console.log(answer)

  if (onSuccess) {
    onSuccess()
  }
  dispatch(fetchedanData())
}

export const updateedanData = (
  edanData: EdanData,
  onSuccess?: (edanData: EdanData) => void,
): AppThunk => async (dispatch) => {
  dispatch(updateedanDataStart())
  const updatededanData = await EdanDataRepository.saveOrUpdate(edanData)
  //dispatch(updateedanDataSuccess(updatededanData))
  if (onSuccess) {
    onSuccess(updatededanData)
  }
}

export default edanSlice.reducer
